/* QUANTICA · Carrito.

   Mejora progresiva de punta a punta:
   - Sin este archivo el icono del header es un link a /cart, que esta
     maquetada igual que el drawer, y el add to cart del bloque de compra es
     un form normal que postea y recarga. Nadie queda sin poder comprar.
   - Con el archivo, todo pasa por la Cart API y el drawer se abre encima.

   No hay estado en JS. Despues de cada operacion se pide de nuevo la seccion
   del drawer al Section Rendering API y se reemplaza el interior: la fuente
   de verdad es siempre el carrito de Shopify, nunca una copia local que
   pueda quedar desfasada.
*/

(function () {
  var SECTION = 'cart-drawer';

  function money(cents) {
    return (cents / 100).toFixed(2);
  }

  var Drawer = {
    el: null,
    abridor: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;

      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          this.cerrar();
        }
      }.bind(this));

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !this.el.hidden) this.cerrar();
        if (e.key === 'Tab' && !this.el.hidden) this.atraparFoco(e);
      }.bind(this));
    },

    abrir: function (disparador) {
      if (!this.el) return;
      this.abridor = disparador || document.activeElement;
      this.el.hidden = false;
      document.documentElement.classList.add('q-no-scroll');
      /* El boton, no el scrim: el scrim tambien lleva data-cart-close pero es
         un div y .focus() sobre el no hace nada, asi que el foco se quedaba
         en el body y el lector de pantalla no entraba nunca al dialogo. */
      var f = this.el.querySelector('button[data-cart-close]');
      if (f) f.focus();
    },

    cerrar: function () {
      if (!this.el) return;
      this.el.hidden = true;
      document.documentElement.classList.remove('q-no-scroll');
      if (this.abridor && this.abridor.focus) this.abridor.focus();
    },

    /* El drawer es un dialogo modal: el tabulador no puede salirse de el. */
    atraparFoco: function (e) {
      var f = this.el.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!f.length) return;
      var primero = f[0];
      var ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    },

    /* Bloquea el panel mientras la operacion esta en vuelo, para que un
       doble toque no agregue dos veces. Es puramente funcional: no pinta
       nada. El porque esta explicado en q-cart.css, junto a la regla. */
    ocupado: function (si) {
      if (!this.el) return;
      this.el.classList.toggle('q-drawer--busy', !!si);
    },

    /* Vuelve a pedir cada seccion y reemplaza solo su interior.
       En /cart conviven dos raices —la de la pagina y la del drawer, que
       vive en el layout— y cada una tiene sus propios recomendados. Por eso
       se refresca cada una contra SU seccion y no se copia una sobre otra. */
    refrescar: function () {
      var raices = Array.prototype.slice.call(document.querySelectorAll('[data-cart-root]'));
      var ids = raices.map(function (n) { return n.getAttribute('data-cart-root'); });
      var unicos = ids.filter(function (v, i) { return v && ids.indexOf(v) === i; });
      if (!unicos.length) unicos = [SECTION];

      return fetch(window.Shopify.routes.root + '?sections=' + unicos.join(','))
        .then(function (r) { return r.json(); })
        .then(function (secciones) {
          raices.forEach(function (raiz) {
            var html = secciones[raiz.getAttribute('data-cart-root')];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nuevo = doc.querySelector('[data-cart-root]');
            if (nuevo) raiz.innerHTML = nuevo.innerHTML;

            var cuenta = doc.querySelector('[data-cart-count]');
            if (cuenta) {
              document.querySelectorAll('[data-cart-count]').forEach(function (n) {
                n.textContent = cuenta.textContent;
              });
            }
          });
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (carrito) {
          document.querySelectorAll('[data-cart-badge]').forEach(function (n) {
            n.textContent = carrito.item_count;
            n.hidden = carrito.item_count === 0;
          });
          document.dispatchEvent(new CustomEvent('quantica:cart', { detail: carrito }));
          return carrito;
        });
    },

    pedir: function (ruta, cuerpo) {
      this.ocupado(true);
      return fetch(window.Shopify.routes.root + ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'cart error');
          return this.refrescar();
        }.bind(this))
        .catch(function (err) {
          /* Si la API falla, el carrito de Shopify sigue siendo la verdad:
             mandamos a /cart en vez de dejar al cliente sin salida. */
          console.error('[quantica cart]', err);
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .finally(function () { this.ocupado(false); }.bind(this));
    }
  };

  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-cart-open]');
    if (abrir) {
      if (!document.querySelector('[data-cart-drawer]')) return; /* deja pasar el link a /cart */
      e.preventDefault();
      Drawer.abrir(abrir);
      return;
    }

    var add = e.target.closest('[data-cart-add]');
    if (add) {
      e.preventDefault();
      Drawer.pedir('cart/add.js', { items: [{ id: Number(add.getAttribute('data-cart-add')), quantity: 1 }] })
        .then(function () { Drawer.abrir(add); });
      return;
    }

    var cambio = e.target.closest('[data-cart-change]');
    if (cambio) {
      e.preventDefault();
      Drawer.pedir('cart/change.js', {
        id: cambio.getAttribute('data-cart-key'),
        quantity: Number(cambio.getAttribute('data-cart-change'))
      });
    }
  });

  /* El form de compra de la PDP: agrega por API y abre el drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form || !document.querySelector('[data-cart-drawer]')) return;
    e.preventDefault();
    var datos = new FormData(form);
    var cuerpo = {
      items: [{ id: Number(datos.get('id')), quantity: Number(datos.get('quantity') || 1) }]
    };
    Drawer.pedir('cart/add.js', cuerpo).then(function () { Drawer.abrir(form); });
  });

  if (!customElements.get('q-cart-drawer')) {
    customElements.define('q-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        Drawer.init();
        this.setAttribute('data-enhanced', 'true');
      }
    });
  }

  window.QuanticaCart = Drawer;
})();
